var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-218 -61)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.275 61c-.95 0-1.724.76-1.724 1.693 0 .325.094.629.256.887l-3.56 4.137a1.741 1.741 0 00-1.71.21l-3-2.13c.042-.147.066-.302.066-.463 0-.934-.774-1.694-1.724-1.694s-1.724.76-1.724 1.694c0 .313.087.606.238.858l-2.966 3.476a1.74 1.74 0 00-.703-.148c-.95 0-1.724.76-1.724 1.694 0 .933.773 1.693 1.724 1.693.95 0 1.724-.76 1.724-1.693 0-.302-.082-.586-.223-.832l2.978-3.49a1.741 1.741 0 001.728-.218l2.993 2.123a1.66 1.66 0 00-.071.48c0 .934.773 1.693 1.724 1.693.95 0 1.723-.76 1.723-1.693 0-.315-.088-.61-.241-.863l3.57-4.15c.2.079.418.123.646.123.95 0 1.724-.76 1.724-1.694 0-.933-.774-1.693-1.724-1.693z",
    fill: "#D6DCDF"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#ECECEC",
    x: 142.5,
    y: 53.5,
    width: 173,
    height: 27,
    rx: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineGray);
export default __webpack_public_path__ + "static/media/line-gray.257c78036f59919cbf375e018af49345.svg";
export { ForwardRef as ReactComponent };